import {
  Container,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Radio,
} from '@mui/material';
import {
  LocalizationProvider ,
  DatePicker,
} from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import React, { useState, useEffect, useRef } from 'react';
import { obtenerCampanas } from '../../../actions/CampanasAction.js';
import TMetricas from './TMetricas';
import style from '../../Tools/Style';
const Metricas = () => {
  const mounted = useRef(true);
  const [campana, setCampana] = useState([]);
  const [Datac, setDatac] = useState([]);
  const [fechaSeleccionadaD, setFechaSeleccionadaD] = useState(new Date());
  const [fechaSeleccionadaH, setFechaSeleccionadaH] = useState(new Date());
  const [radioValor, setRadioValor] = useState('General');
  const [mostrarMetricas, setMostrarMetricas] = useState(false);
  
  const radioValorHandleChange = (event) => {
    setRadioValor(event.target.value);
  };

  const selectCampanaHandleChange = (event) => {
    setCampana(event.target.value);
  };

  const mostrarTMetricas = () => {
    setMostrarMetricas(true);
  };

  useEffect(() => {
    if (mounted.current) {
      obtenerCampanas().then((response) => {
        if (response.status === 200) {
          setDatac(response.data);
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  return (
    <Container component="main" maxWidth="md" justify="center">
      <br />
      <Typography align="center" component="h1" variant="h6">
        Métricas de Marketing
      </Typography>
      <Typography component="h3" variant="h6">
        Seleccionar Campaña
      </Typography>
      <FormControl variant="outlined" style={style.Select2.Campana}>
        <InputLabel style={style.Select2}>Campañas</InputLabel>
        <Select
          value={campana}
          onChange={selectCampanaHandleChange}
          label="Campaña"
        >
          <MenuItem value="">
            <em>Ninguno</em>
          </MenuItem>
          {Datac.map((campana) => (
            <MenuItem key={campana.campanA_Id} value={campana}>
              {campana.descricampana}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <br /> <br />
      <Typography component="h3" variant="h6">
        Parámetros para Cálculo
      </Typography>
      <br />
      <Typography component={'div'}>
        General :
        <Radio
          checked={radioValor === 'General'}
          onChange={radioValorHandleChange}
          value="General"
          color="primary"
        />
        Mensual :
        <Radio
          checked={radioValor === 'Mensual'}
          onChange={radioValorHandleChange}
          value="Mensual"
          color="primary"
        />
      </Typography>

      {radioValor === 'Mensual' ? (
        <div>
          <LocalizationProvider  locale={esLocale} utils={DateFnsUtils}>
            <DatePicker
              value={fechaSeleccionadaD}
              onChange={setFechaSeleccionadaD}
              margin="normal"
              id="fecha-vencimiento-id"
              label="Desde"
              format="dd/MM/yyyy"
              fullWidth
              multiline
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider  locale={esLocale} utils={DateFnsUtils}>
            <DatePicker
              value={fechaSeleccionadaH}
              onChange={setFechaSeleccionadaH}
              margin="normal"
              id="fecha-vencimiento-id"
              label="Hasta"
              format="dd/MM/yyyy"
              fullWidth
              multiline
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </LocalizationProvider>
        </div>
      ) : null}

      <Button
        variant="contained"
        color="primary"
        style={style.submit}
        onClick={mostrarTMetricas}
      >
        Calcular
      </Button>

      {mostrarMetricas === true ? (
        <TMetricas
          desde={fechaSeleccionadaD}
          hasta={fechaSeleccionadaH}
          radio={radioValor}
          campana_id={campana.campanA_Id}
        />
      ) : null}
      
    </Container>
  );
};
export default Metricas;
